/**
 *  상품 후기 리스트 필터 옵션 모델
 */
export const CS_REVIEW_LIST_FILTER_OPTION_MODEL = {
  /**
   *  상품 후기 ID
   */
  id: null,
  /**
   *  상품 리뷰의 상태
   */
  status: null,
  /**
   * 상품 신고 여부
   */
  isReported: null,
  /**
   *  상품 리뷰의 별점
   */
  rate: null,
  /**
   *  상품 리뷰의 첨부파일 존재 여부
   */
  hasAttachments: null,
  /**
   *  상품 리뷰의 상품 id
   */
  productId: null,
  /**
   *  상품 리뷰의 상품명
   */
  productName: null,
  /**
   *  상품 리뷰의 상점명
   */
  storeName: null,
  /**
   *  상품 리뷰의 상점 ID
   */
  storeId: null,
  /**
   *  상품 리뷰의 상품 주문번호
   */
  orderItemId: null,
  /**
   *  상품 리뷰의 구매자 ID
   */
  userId: null,
  /**
   *  상품 리뷰의 구매자명
   */
  userName: null,
  /**
   *  상품 리뷰의 구매평
   */
  content: null,
  /**
   *  상품 리뷰의 작성일
   */
  createStartDate: null,
  createEndDate: null,
};

/**
 *  상품 후기 리스트 필터 옵션 모델
 */
export const CS_REVIEW_LIST_SORT_OPTION_MODEL = {
  sort: '',
};

/**
 *  상품 후기 리스트 페이지네이션 옵션 모델
 */
export const CS_REVIEW_LIST_PAGINATION_MODEL = {
  pageIndex: 1,
  pageSize: 100,
};
